import { FileSearch } from 'lucide-react';
import { Link } from 'react-router-dom';

import { Button } from '@/components/ui/button';
import { RestrictedPage } from '@/components/layout/RestrictedPage';

export function NotFound() {
	return (
		<RestrictedPage>
			<div className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-soft text-primary-soft-foreground">
				<FileSearch className="h-6 w-6" />
			</div>
			<h1 className="text-2xl font-extrabold tracking-tight">Page not found</h1>
			<p className="max-w-sm text-sm text-muted-foreground">The page you tried to access doesn't exist, or has been moved.</p>
			<Button asChild>
				<Link to="/">Back to dashboard</Link>
			</Button>
		</RestrictedPage>
	);
}
